import { Component } from '@angular/core';

@Component({
  selector: 'app-psgact',
  templateUrl: './psgact.component.html',
  styleUrls: ['./psgact.component.scss']
})
export class PSGActComponent {

}
